/** @format */
import moment from "moment";
import {
  FETCH_HOME_HOTELS,
  SET_HOME_HOTELS,
  FETCH_PROPERTY_TYPE,
  SET_PROPERTY_TYPE,
  FETCH_COUNTRIES,
  SET_COUNTRIES,
  FETCH_REGION,
  SET_REGION,
  SET_HOTEL,
  FETCH_HOTEL,
  SET_FILTERED_ROOMS,
  FETCH_FILTERED_ROOMS,
  FETCH_FILTERED_ROOMS_OCCUPANCY,
  SET_FILTERED_HOTELS,
  FETCH_FILTERED_HOTELS,
  FETCH_FILTERED_HOTELS_SIGNIX,
  FETCH_SIGNIX_PRICE_VALIDATION,
  SIGNIX_PRE_BOOK,
  SIGNIX_BOOK_COMPLETE,
  SET_HOTEL_NAMES,
  FETCH_HOTEL_NAMES,
  SET_MEAL_PLANE,
  FETCH_MEAL_PLANE,
  FETCH_DISCOUNT_PRICE,
  SET_DISCOUNT_PRICE,
  SET_HOLD_TIMESTAMP,
  FETCH_HOLD_TIMESTAMP,
  REMOVE_HOLD_ROOMS,
  SET_VALID_ROOM_AND_BILLING,
  VALIDATE_ROOM_CREATE_BILLING,
  BUY_ROOM,
  SET_BOUGHT_ROOM,
  FETCH_SMS_PRICE,
  SET_SMS_PRICE,
  SAVE_API_BODY,
  SET_API_BODY,
  HOTEL_PAYMENT_CANCEL,
  RESET_STATE,
  RESET_DISCOUNT_PRICE,
  SET_DISCOUNT_MESSAGE,
  RESET_DISCOUNT_MESSAGE,
  ROOM_PAYMENT_COMPLETE,
  SET_ROOM_PAYMENT_COMPLETE,
  SET_FINAL_TRANSACTION,
  FETCH_ALL_ROOMS_BY_HOTEL_ID,
  SET_ALL_ROOMS_BY_HOTEL_ID,
  VALIDATE_GLOBAL_PROMOCODE,
  FETCH_HOTEL_DETAIL_SIGNIX,
  SIGNIX_CONFIRMED_HOTEL,
  SIGNIX_CANCEL_HOTEL,
} from "./actions.type";
import ApiService from "@/common/api.services";
import localStorageServices from "@/common/jwt.services";

// Helper function to calculate number of nights from checkin and checkout dates
const calculateNights = (checkInDate, checkOutDate) => {
  if (!checkInDate || !checkOutDate) return 1; // Default to 1 night if dates are missing
  
  try {
    const checkIn = moment(checkInDate);
    const checkOut = moment(checkOutDate);
    const nights = checkOut.diff(checkIn, 'days');
    return nights > 0 ? nights : 1; // Ensure at least 1 night
  } catch (error) {
    console.error('Error calculating nights:', error);
    return 1; // Default to 1 night on error
  }
};

// Transformation function
const transformHotelData = (data) => {
  localStorageServices.setObject("hotelSessionId", data.SessionId);
    return data.Hotels.map((hotel) => {
      const shortDescription = hotel.Features.find((f) => f.Type === "PropertyLocationDescription");
  return {

    location: {
      latitude: hotel.HotelAddress.Latitude || "",
      longitude: hotel.HotelAddress.Longitude || "",
      latLng:hotel.HotelAddress.Latitude && hotel.HotelAddress.Longitude ? `${hotel.HotelAddress.Latitude},${hotel.HotelAddress.Longitude}`: "",
      address: hotel.HotelAddress.Address
        ? hotel.HotelAddress.Address.replace(/\r\n/g, ", ")
        : "",
      city: hotel.HotelAddress.City || "",
      country: hotel.HotelAddress.City ? "Mauritius" : "",
      timezone: hotel.HotelAddress.City ? "indian/mauritius" : "",
      mapLink:
        hotel.HotelAddress.Latitude && hotel.HotelAddress.Longitude
          ? `https://www.google.com/maps?q=${hotel.HotelAddress.Latitude},${hotel.HotelAddress.Longitude}`
          : "",
    },
    SessionID: data.SessionId,
    name: hotel.HotelName,
    propertyType: {
      _id: hotel.HotelCategory ? "66bb17a3263294406f9a1e03" : "",
      title: hotel.HotelCategory || "",
      slug: hotel.HotelCategory
        ? `${hotel.HotelCategory.toLowerCase().replace(/\s+/g, "-")}-1723537315437`
        : "",
    },
    region: {
      _id: hotel.HotelAddress.City ? "66bb168c263294406f9a1dee" : "",
      title: hotel.HotelAddress.City || "",
      slug: hotel.HotelAddress.City
        ? `${hotel.HotelAddress.City.toLowerCase().replace(/\s+/g, "-")}-1723537036676`
        : "",
    },
    slug: hotel.HotelName ? hotel.HotelName.toLowerCase().replace(/\s+/g, "-") : "",
    tagLine: "",
    title: hotel.HotelName || "",
    // tags: hotel.Amenities.filter(a => a.Important).slice(0, 3).map(a => ({
    //   _id: a.AmenityId || "",
    //   title: a.Description || "",
    //   color: ""
    // })) || [],
    tags: [],
    HotelProviderSearchId: hotel.HotelProviderSearchId,
    cityId: Number(hotel.CityId),
    _id: hotel.HotelProviderSearchId || "",
    displayNotes: "",
    shortDescription: shortDescription ? shortDescription.Description : "",
    imageBadge: [],
    serviceRating: hotel.StarRating ? Math.round(parseFloat(hotel.StarRating)) : 0,
    discount: "",
    isPromotional: hotel.HotelServices.some((s) => s.HasPromotion) || false,
    source: "external",
    providerReferences: {
      provider: hotel.HotelServices[0].ProviderName || "",
      providerHotelId: hotel.HotelProviderSearchId || "",
      cityId: hotel.CityId || "",
      lastSynced: "",
      _id: hotel.HotelProviderSearchId ? `${hotel.HotelProviderSearchId}-provider` : "",
    },
    mealPlans: hotel.MealPlans || [],
    specificDatePrice: [],
    hotel_details: {
      leastPrice: {
        price: hotel.LBookPrice ? hotel.LBookPrice.toString() : "",
      },
      mostPrice: {
        price: hotel.HBookPrice ? hotel.HBookPrice.toString() : "",
      },
      mealPlans: hotel.MealPlans || [],
    },
    rooms: {
      effectivePrice: hotel.HotelServices[0].ServicePrice || 0,
      isSold: false,
      minNights: 1,
      specificDatePrice: [],
      pricing: {
        totalAmount: hotel.HotelServices[0].ServicePrice,
        // Calculate amount per room or per night
        // If HotelsSearchRequest has dates, calculate per night; otherwise per room
        amount: (() => {
          const servicePrice = hotel.HotelServices[0].ServicePrice || 0;
          const numRooms = data.HotelsSearchRequest.Rooms.length || 1;
          
          // Check if we have checkin/checkout dates for per-night calculation
          if (data.HotelsSearchRequest.CheckInDate && data.HotelsSearchRequest.CheckOutDate) {
            const nights = calculateNights(
              data.HotelsSearchRequest.CheckInDate,
              data.HotelsSearchRequest.CheckOutDate
            );
            // Per night: total price divided by (rooms * nights)
            return nights > 0 ? servicePrice / (numRooms * nights) : servicePrice / numRooms;
          } else {
            // Per room: total price divided by number of rooms
            return servicePrice / numRooms;
          }
        })(),
      },
      roomName: hotel.HotelServices[0].Rooms[0].RoomName || "",
    },
    image: {
      url: hotel.HotelImages[0] || "",
    },
  };
});
};
const transformHotelDetailData = (hotel) => {
  const checkInInstruction = hotel.Features.find((f) => f.Type === "CheckInInstruction");
  const shortDescription = hotel.Features.find((f) => f.Type === "Description");
  const CheckInInstruction = hotel.Features.find((f) => f.Type === "CheckInInstruction");
  const CheckInSpecialInstruction = hotel.Features.find((f) => f.Type === "CheckInSpecialInstruction");
  const PropertyMandatoryFeesDescription = hotel.Features.find((f) => f.Type === "PropertyMandatoryFeesDescription");
  const AreaAttractions = hotel.Features.find((f) => f.Type === "AreaAttractions");

  const CheckInTime = hotel.CheckInTime || null;
  const CheckOutTime = hotel.CheckOutTime || null;


  return {
    hotelRooms: hotel.HotelServices,
    location: {
      latitude: hotel.HotelAddress.Latitude || "",
      longitude: hotel.HotelAddress.Longitude || "",
      latLng:
        hotel.HotelAddress.Latitude && hotel.HotelAddress.Longitude
          ? `${hotel.HotelAddress.Latitude},${hotel.HotelAddress.Longitude}`
          : "",
      address: hotel.HotelAddress.Address
        ? hotel.HotelAddress.Address.replace(/\r\n/g, ", ")
        : "",
      city: hotel.HotelAddress.City || "",
      country: hotel.HotelAddress.City ? "Mauritius" : "",
      timezone: hotel.HotelAddress.City ? "indian/mauritius" : "",
      mapLink:
        hotel.HotelAddress.Latitude && hotel.HotelAddress.Longitude
          ? `https://www.google.com/maps?q=${hotel.HotelAddress.Latitude},${hotel.HotelAddress.Longitude}`
          : "",
    },
    instructions: checkInInstruction ? checkInInstruction.Description : "",
    checkInInstruction: CheckInInstruction ? CheckInInstruction.Description : "",
    checkInSpecialInstruction: CheckInSpecialInstruction ? CheckInSpecialInstruction.Description : "",
    propertyMandatoryFeesDescription: PropertyMandatoryFeesDescription ? PropertyMandatoryFeesDescription.Description : "",
    areaAttractions: AreaAttractions ? AreaAttractions.Description : "",
    checkInTime: CheckInTime,
    checkOutTime: CheckOutTime,


    checkListIds: hotel.Amenities.map((a) => ({
      _id: a.AmenityId || "",
      title: a.Description || "",
      popular: a.Important || false,
      color: "",
    })) || [],

    allRoomClosedDates: {},
    availability: {},

    closedDates: [],
    description: hotel.Description,
    shortDescription: shortDescription ? shortDescription.Description : "",
    hotelMedia: {
      media: {
        images: Array.isArray(hotel.HotelImages)
          ? hotel.HotelImages.map((img, i) => ({
              fileType: img.endsWith(".png") ? "image/png" : "image/jpeg", // simple guess, tum apni logic bhi laga sakte ho
              url: img,
            }))
          : [],
      },
    },
    videos: [],
    hotel_details: {},
    promoter: [],

    latLng:
      hotel.HotelAddress.Latitude && hotel.HotelAddress.Longitude
        ? `${hotel.HotelAddress.Latitude},${hotel.HotelAddress.Longitude}`
        : "",
    address: hotel.HotelAddress.Address
      ? hotel.HotelAddress.Address.replace(/\r\n/g, ", ")
      : "",
    city: hotel.HotelAddress.City || "",
    cityId: Number(hotel.CityId),
    country: hotel.HotelAddress.City ? "Mauritius" : "",
    timezone: hotel.HotelAddress.City ? "indian/mauritius" : "",
    mapLink:
      hotel.HotelAddress.Latitude && hotel.HotelAddress.Longitude
        ? `https://www.google.com/maps?q=${hotel.HotelAddress.Latitude},${hotel.HotelAddress.Longitude}`
        : "",
    name: hotel.HotelName,

    slug: hotel.HotelName ? hotel.HotelName.toLowerCase().replace(/\s+/g, "-") : "",
    tagLine: "",
    title: hotel.HotelName || "",

    HotelProviderSearchId: hotel.HotelProviderSearchId,
    _id: hotel.HotelProviderSearchId || "",
    displayNotes: "",
    imageBadge: [],
    serviceRating: hotel.StarRating ? Math.round(parseFloat(hotel.StarRating)) : 0,
    discount: "",
    isPromotional: hotel.HotelServices.some((s) => s.HasPromotion) || false,
    source: "external",

    mealPlans: hotel.MealPlans || [],
    specificDatePrice: [],
    hotel_details: {
      leastPrice: {
        price: hotel.LBookPrice ? hotel.LBookPrice.toString() : "",
      },
      mostPrice: {
        price: hotel.HBookPrice ? hotel.HBookPrice.toString() : "",
      },
      mealPlans: hotel.MealPlans || [],
    },
    propertyType: {
      _id: hotel.HotelCategory ? "66bb17a3263294406f9a1e03" : "",
      title: hotel.HotelCategory || "",
      slug: hotel.HotelCategory
        ? `${hotel.HotelCategory.toLowerCase().replace(/\s+/g, "-")}-1723537315437`
        : "",
    },
    region: {
      _id: hotel.HotelAddress.City ? "66bb168c263294406f9a1dee" : "",
      title: hotel.HotelAddress.City || "",
      slug: hotel.HotelAddress.City
        ? `${hotel.HotelAddress.City.toLowerCase().replace(/\s+/g, "-")}-1723537036676`
        : "",
    },

    //   image: {
    //     url: hotel.HotelImages[0] || '',
    //  }
  };
};

const state = {
  currency: "MUR",
  isPromotionalExists: false,
  isLoadingHotels: false,
  hotelDetailLoading: false,
  final_transaction: null,
  homeHotels: [],
  allRoomsByHotelId: [],
  propertyTypes: [],
  countries: [],
  regions: [],
  filteredHotels: [],
  filterHotelsCount: 0,
  hotelNames: [],
  homeHotelCount: null,
  propertyTypeCount: null,
  countryCount: null,
  regionCount: null,
  filteredRooms: null,
  mealPlans: [],
  discountedPrice: { message: "", discount: null },
  hotel: {},
  isLoading: false,
  cachedTime: null,
  roomBilling: null,
  boughtRoom: {},
  systemPricing: null,
  filteredRoomsMsg: "",
  apiBody: {},
  mealPlanNames: null,
  signixHotelRequestsCount: 0,
};

const getters = {
  homeHotels() {
    return state.homeHotels;
  },
  propertyTypes() {
    return state.propertyTypes;
  },
  mealPlanNames() {
    return state.mealPlanNames;
  },
  countries() {
    return state.countries;
  },
  regions() {
    return state.regions;
  },
  rooms(state) {
    return state.filteredRooms ? state.filteredRooms.results : state.allRoomsByHotelId;
  },
  search(state) {
    return state.filteredRooms ? state.filteredRooms.search : null;
  },
  meal_Plans(state) {
    return state.mealPlans.map(({ name, _id }) => ({
      name,
      _id,
    }));
  },
  smsCharges(state) {
    if ((state.systemPricing || []).length) {
      const sms = state.systemPricing.find(({ title }) => title === "SMS Charges");
      return sms.amount;
    }
  },
  popularFacilities(state) {
    if (!_.isEmpty(state.hotel))
      return _.get(state, "hotel.checkListIds", []).filter(
        ({ listType }) => listType === "popular"
      );
  },
  otherFacilities(state) {
    if (!_.isEmpty(state.hotel)) {
      // const facilities = _.get(state, 'hotel.checkListIds', []).filter(
      //   ({ listType }) => listType === 'other'
      // );
      const facilities = state.hotel.checkListIds;
      return facilities;
    }
  },
  getRoom: (state) => (roomId) => {
    return (
      state.filteredRooms && state.filteredRooms.results.find(({ _id }) => _id === roomId)
    );
  },
};

const actions = {
  [FETCH_HOME_HOTELS]({ commit }, params) {
    state.isLoading = true;
    return ApiService.getWithParams('hotel/home', { params })
      .then(({ data: { response: res } }) => {
        commit(SET_HOME_HOTELS, res);
        state.isLoading = false;
        return res;
      })
      .catch((error) => {
        state.isLoading = false;
        console.error(error);
        return error.response.status;
      });
  },
  [FETCH_PROPERTY_TYPE]({ commit }, params) {
    state.isLoading = true;
    return ApiService.getWithParams('property-types', { params })
      .then(({ data: { response: res } }) => {
        commit(SET_PROPERTY_TYPE, res);
        state.isLoading = false;
        return res;
      })
      .catch((error) => {
        state.isLoading = false;
        console.error(error);
        return error.response.status;
      });
  },
  [FETCH_COUNTRIES]({ commit }, params) {
    state.isLoading = true;
    return ApiService.getWithParams('countries', { params })
      .then(({ data: { response: res } }) => {
        commit(SET_COUNTRIES, res.data);
        state.isLoading = false;
        return res;
      })
      .catch((error) => {
        state.isLoading = false;
        console.error(error);
        return error.response.status;
      });
  },
  [FETCH_REGION]({ commit }, params) {
    state.isLoading = true;
    return ApiService.getWithParams('regions', { params })
      .then(({ data: { response: res } }) => {
        commit(SET_REGION, res);
        state.isLoading = false;
        return res;
      })
      .catch((error) => {
        state.isLoading = false;
        console.error(error);
        return error.response.status;
      });
  },
  [FETCH_FILTERED_ROOMS]({ commit }, params) {
    state.isLoading = true;
    return ApiService.getWithParams('admin/room', { params })
      .then(({ data: { response: res } }) => {
        commit(SET_FILTERED_ROOMS, res);
        state.isLoading = false;
        return res;
      })
      .catch((error) => {
        state.isLoading = false;
        console.error(error.message);
        commit(
          SET_FILTERED_ROOMS,
          'Sorry, No Rooms available on your specified date.'
        );
        return error.response.status;
      });
  },
  [FETCH_FILTERED_ROOMS_OCCUPANCY]({ commit }, params) {
    state.isLoading = true;
    const resource = `rooms/${params.id}`;
    delete params.id;
    return ApiService.getWithParams(resource, { params })
      .then(({ data: { response: res } }) => {
        state.isLoading = false;
        return res;
      })
      .catch((error) => {
        state.isLoading = false;
        return error.response.status;
      });
  },
  [FETCH_ALL_ROOMS_BY_HOTEL_ID]({ commit }, id) {
    state.isLoading = true;
    return ApiService.get(`rooms`, id)
      .then(({ data: { response: res } }) => {
        commit(SET_ALL_ROOMS_BY_HOTEL_ID, res);
        state.isLoading = false;
        return res;
      })
      .catch((error) => {
        state.isLoading = false;
        console.error(error);
        return error.response.status;
      });
  },
  [FETCH_HOTEL]({ commit }, data) {
    state.isLoading = true;
    state.hotelDetailLoading = true;
    return ApiService.get('hotel', data)
      .then(({ data: { response: res } }) => {
        commit(SET_HOTEL, res);
        state.isLoading = false;
        state.hotelDetailLoading = false;
        return res;
      })
      .catch((error) => {
        state.isLoading = false;
        console.error(error);
        return error.response.status;
      });
  },

  // Update FETCH_HOTEL_DETAIL_SIGNIX action

  [FETCH_FILTERED_HOTELS]({ commit }, params) {
    state.isLoadingHotels = true;
    state.filterHotelsCount = 0;

    return ApiService.getWithParams('/hotel', { params })
      .then(({ data: { response: res } }) => {
        commit(SET_FILTERED_HOTELS, res);
        return res;
      })
      .catch((error) => {
        state.isLoadingHotels = false;
        console.error(error);
        return error;
      });
  },
  [ROOM_PAYMENT_COMPLETE]({ commit }, { billingId, paymentResponse }) {
    state.isLoading = true;

    // Conditional body banana
    const body = paymentResponse ? { paymentResponse } : undefined;

    return ApiService.put(`/booking/payment/complete/${billingId}`, body)
      .then((res) => true)
      .catch((error) => {
        state.isLoading = false;
        console.error(error);
        return error.response.status;
      });
  },

  [FETCH_MEAL_PLANE]({ commit }, data) {
    state.isLoading = true;
    return ApiService.get('/admin/mealplan', data)
      .then((res) => {
        commit(SET_MEAL_PLANE, res.data);
        return res;
      })
      .catch((error) => {
        state.isLoading = false;
        console.error(error);
        return error.response.status;
      });
  },
  [FETCH_DISCOUNT_PRICE]({ commit }, params) {
    state.isLoading = true;
    return ApiService.post('/apply-global-promocode', params)
      .then(({ data }) => {
        commit(SET_DISCOUNT_PRICE, data.response);
        return data.response;
      })
      .catch((error) => {
        console.log(error);
        state.isLoading = false;

        return error.response.status;
      });
  },
  [FETCH_FILTERED_HOTELS_SIGNIX]({ commit }, params) {
    if (params.checkin) {
      params.checkin = moment(params.checkin, 'DD-MM-YYYY').format(
        'YYYY-MM-DD'
      );
    }
    if (params.checkout) {
      params.checkout = moment(params.checkout, 'DD-MM-YYYY').format(
        'YYYY-MM-DD'
      );
    }
    if (!params.checkin || !params.checkout) {
      return;
    }

    state.isLoadingHotels = true;
    state.filterHotelsCount = 0;
    state.signixHotelRequestsCount++;


    const numRooms = parseInt(params.room) || 1;
    const numAdults = parseInt(params.adult) || 1;
    const numChildren = parseInt(params.children) || 0;
    const numTeens = parseInt(params.teen) || 0;

    const adultsPerRoom = Math.floor(numAdults / numRooms);
    const extraAdults = numAdults % numRooms;
    const childrenPerRoom = Math.floor(numChildren / numRooms);
    const extraChildren = numChildren % numRooms;
    const teensPerRoom = Math.floor(numTeens / numRooms);
    const extraTeens = numTeens % numRooms;

    const rooms = [];
    let ageIndex = 0; // ✅ new line added to track child ages

    for (let i = 0; i < numRooms; i++) {
      const roomAdults = adultsPerRoom + (i < extraAdults ? 1 : 0);
      const roomChildren = childrenPerRoom + (i < extraChildren ? 1 : 0);
      const roomTeens = teensPerRoom + (i < extraTeens ? 1 : 0);

      const room = {
        RoomNo: String(i + 1),
        Adults: roomAdults,
        Children: roomChildren,
        Paxs: [],
      };

      // ✅ FIX: assign only this room’s child ages instead of all
      if (roomChildren > 0 && Array.isArray(params.age)) {
        const childAges = params.age.slice(ageIndex, ageIndex + roomChildren);
        room.Paxs = childAges.map((a) => ({
          PaxType: 'C',
          Age: Number(a),
        }));
        ageIndex += roomChildren;
      }

      rooms.push(room);
    }

    const payload = {
      SearchId: process.env.VUE_APP_SYNXIS_SEARCH_ID,
      PageNo: 1,
      PageSize: params.limit || 10,
      HotelID: null,
      SessionID: null,
      TravellerNationality: process.env.VUE_APP_SYNXIS_TRAVELER_NATIONALITY,
      CheckInDate: params.checkin || null,
      CheckOutDate: params.checkout || null,
      Currency: process.env.VUE_APP_SYNXIS_CURRENCY,
      Rooms: rooms,
      ShowDetail: true,
      Filter: {
        MinPrice: params.lPrice ? params.lPrice : 0.0,
        MaxPrice: params.gPrice ? params.gPrice : 999999999.0,
        MealPlans:
          params.mealPlan && params.mealPlan.length > 0
            ? params.mealPlan.join(',')
            : null,
        StarRatings:
          params.serviceRating && params.serviceRating.length > 0
            ? params.serviceRating.map((r) => r.toFixed(1)).join(',')
            : null,
        Hotels:
          params.hotelName && params.hotelName.length > 0
            ? params.hotelName.join(',')
            : null,
        Favorite: null,
      },
      RoomCriteria: 'A',
      SortCriteria: {
        SortBy: 'StarRating',
        SortOrder: 'Desc',
      },
      SearchProviders: null,
    };

    return ApiService.post('/synxis/hotelSearch', payload)
      .then(({ data: { response: res } }) => {
        let isSignix = JSON.parse(localStorageServices.getObject("isSignix"));
        if (isSignix) {
          commit(SET_FILTERED_HOTELS, res);
        }
        return res.data.hotels;
      })
      .catch((error) => {
        console.error(error);
        return error.response.status;
      })
      .finally(() => {
        state.signixHotelRequestsCount--;
        if (state.signixHotelRequestsCount === 0) {
          state.isLoadingHotels = false;
        }
      });
  },

  [FETCH_HOTEL_DETAIL_SIGNIX](
    { commit },
    { slug, checkIn, checkOut, rooms, hotelID, SessionID, age }
  ) {
    state.isLoading = true;
    state.hotelDetailLoading = true;

    // --- Calculate base room/guest counts ---
    const numRooms = parseInt(rooms[0].RoomNo) || 1;
    const rawAdults = parseInt(rooms[0].Adults) || 0;
    // Ensure at least 1 adult per room for payload distribution
    const numAdults = Math.max(rawAdults, numRooms, 1);
    const numChildren = parseInt(rooms[0].Children) || 0;
    let childAges = [];

    if (Array.isArray(rooms[0].age)) {
      childAges = rooms[0].age.map((a) => parseInt(a, 10));
    } else if (
      typeof rooms[0].age === 'string' ||
      typeof rooms[0].age === 'number'
    ) {
      childAges = [parseInt(rooms[0].age, 10)];
    }


    const roomsDetail = [];

    // 🧠 Split adults/children evenly across rooms
    const adultsPerRoom = Math.floor(numAdults / numRooms);
    const extraAdults = numAdults % numRooms;
    const childrenPerRoom = Math.floor(numChildren / numRooms);
    const extraChildren = numChildren % numRooms;

    for (let i = 0; i < numRooms; i++) {
      const roomAdults = adultsPerRoom + (i < extraAdults ? 1 : 0);
      const roomChildren = childrenPerRoom + (i < extraChildren ? 1 : 0);

      const paxList = [];

      // --- Assign children with ages to each room ---
      if (childAges.length && roomChildren > 0) {
        for (let j = 0; j < roomChildren && childAges.length > 0; j++) {
          paxList.push({
            PaxType: 'C',
            Age: childAges.shift(), // use and remove
        });
        }
      }

      roomsDetail.push({
        RoomNo: String(i + 1),
        Adults: String(roomAdults),
        Children: String(roomChildren),
        Paxs: paxList,
      });
    }

    // --- Payload build ---
    const payload = {
      // SearchId: process.env.VUE_APP_SYNXIS_SEARCH_ID,
      PageNo: 1,
      PageSize: 10,
      HotelID: hotelID,
      // SessionID: SessionID,
      TravellerNationality: process.env.VUE_APP_SYNXIS_TRAVEL_NATIONALITY,
      CheckInDate: checkIn || null,
      CheckOutDate: checkOut || null,
      Currency: process.env.VUE_APP_SYNXIS_CURRENCY,
      Rooms: roomsDetail, // ✅ includes Paxs
      ShowDetail: true,
      Filter: {
        MinPrice: 0.0,
        MaxPrice: 999999999.0,
        MealPlans: null,
        StarRatings: '',
        Hotels: null,
        Favorite: null,
      },
      RoomCriteria: 'A',
      SortCriteria: {
        SortBy: 'StarRating',
        SortOrder: 'Desc',
      },
      SearchProviders: null,
    };

    return ApiService.post('/synxis/hotelSearch', payload)
      .then(({ data: { response: res } }) => {
        commit(
          SET_HOTEL,
          res.data.Hotels ? { data: res.data.Hotels } : { data: null }
        );
        state.isLoading = false;
        state.hotelDetailLoading = false;
        return res.data.Hotels[0] || null;
      })
      .catch((error) => {
        state.isLoading = false;
        state.hotelDetailLoading = false;
        console.error(error);
        return error.response.status || 500;
      });
  },

  // [FETCH_HOTEL_DETAIL_SIGNIX]({ commit }, { slug, checkIn, checkOut, rooms }) {
  //   state.isLoading = true;
  //   state.hotelDetailLoading = true;

  //   const payload = {
  //     CityId: 21038,
  //     PageNo: 1,
  //     PageSize: 100,
  //     HotelID: slug, // Use slug as HotelID
  //     SessionID: null,
  //     TravellerNationality: 'IN',
  //     CheckInDate: checkIn || null,
  //     CheckOutDate: checkOut || null,
  //     Currency: 'INR',
  //     Rooms: rooms || [
  //       {
  //         RoomNo: '1',
  //         Adults: '2',
  //         Children: '0',
  //         Paxs: null,
  //       },
  //       {
  //         RoomNo: '2',
  //         Adults: '2',
  //         Children: '2',
  //         Paxs: [
  //           { PaxType: 'C', Age: '7' },
  //           { PaxType: 'C', Age: '11' },
  //         ],
  //       },
  //     ],
  //     ShowDetail: true,
  //     Filter: {
  //       MinPrice: 1,
  //       MaxPrice: 99999999,
  //       MealPlans: '',
  //       StarRatings: '',
  //       Hotels: '',
  //       Favorite: '',
  //     },
  //     RoomCriteria: 'A',
  //     SortCriteria: {
  //       SortBy: 'StarRating',
  //       SortOrder: 'Desc',
  //     },
  //   };

  //   return ApiService.post('/signix/hotelDetailWithPrice', payload)
  //     .then(({ data: { response: res } }) => {
  //       commit(
  //         SET_HOTEL,
  //         res.data.HotelDetail ? { data: res.data.HotelDetail } : { data: null }
  //       );
  //       state.isLoading = false;
  //       state.hotelDetailLoading = false;
  //       return res.data.Hotels[0] || null;
  //     })
  //     .catch((error) => {
  //       state.isLoading = false;
  //       state.hotelDetailLoading = false;
  //       console.error(error);
  //       return error.response.status || 500;
  //     });
  // },
  [FETCH_SIGNIX_PRICE_VALIDATION]({ commit }, params) {
    state.isLoading = true;
    return ApiService.post('/synxis/validateServicesHotel', params)
      .then(({ data }) => {
        return { response: data.response.data };
      })
      .catch((error) => {
        state.isLoading = false;
        return { response: error.response.data };
      });
  },
  [SIGNIX_PRE_BOOK]({ commit }, params) {
    state.isLoading = true;
    return ApiService.post('/synxis/preBook', params)
      .then(({ data }) => {
        return { response: data.response.data };
      })
      .catch((error) => {
        state.isLoading = false;
        return { response: error.response.data };
      });
  },
  [SIGNIX_BOOK_COMPLETE]({ commit }, params) {
    state.isLoading = true;
    return ApiService.post('/booking/buySynxisRoom', params)
      .then(({ data }) => {
        return { response: data.response.data };
      })
      .catch((error) => {
        state.isLoading = false;
        return { response: error.response.data };
      });
  },

  //   [FETCH_SIGNIX_PRICE_VALIDATION]({ commit }, params) {
  //   state.isLoading = true;
  //   const SIGNIX_BASE_URL = "https://apidevhp.trateq.com/";

  //   return ApiService.postWithCustomBase("/SIGNIX/B2B/PriceValidation", params, SIGNIX_BASE_URL)
  //     .then(({ data }) => {
  //       state.isLoading = false;
  //       return data.response;
  //     })
  //     .catch((error) => {
  //       state.isLoading = false;
  //       return error.response.status || 500;
  //     });
  // },
  [ROOM_PAYMENT_COMPLETE]({ commit }, { billingId, paymentResponse }) {
    state.isLoading = true;
    const body = paymentResponse ? { paymentResponse } : undefined;
    return ApiService.put(`/booking/payment/complete/${billingId}`, body)
      .then((res) => true)
      .catch((error) => {
        state.isLoading = false;
        console.error(error);
        return error.response.status;
      });
  },
  [SIGNIX_CONFIRMED_HOTEL](
    { commit },
    { billingId, buyerId, paymentGateway, orderStatus }
  ) {
    state.isLoading = true;

    // Body me ye fields bhejni hain
    const body = {
      buyerId,
      paymentGateway,
      orderStatus,
    };

    // billingId URL me bind hoga
    return ApiService.put(`/booking/updateBooking/${billingId}`, body)
      .then((res) => true)
      .catch((error) => {
        state.isLoading = false;
        console.error(error);
        return error.response.status || false;
      });
  },
  [SIGNIX_CANCEL_HOTEL](
    { commit },
    { billingId, buyerId, paymentGateway, orderStatus }
  ) {
    state.isLoading = true;

    // Body me ye fields bhejni hain
    const body = {
      buyerId,
      paymentGateway,
      orderStatus,
    };

    // billingId URL me bind hoga
    return ApiService.put(`/booking/updateBooking/${billingId}`, body)
      .then((res) => true)
      .catch((error) => {
        state.isLoading = false;
        console.error(error);
        return error.response.status || false;
      });
  },

 
  [FETCH_HOTEL_NAMES]({ commit }, params) {
    state.isLoading = true;
    return ApiService.getWithParams('hotel/names', { params })
      .then(({ data: { response: res } }) => {
        commit(SET_HOTEL_NAMES, res);
        state.isLoading = false;
        return res;
      })
      .catch((error) => {
        state.isLoading = false;
        console.error(error);
        return error.response.status;
      });
  },
  [FETCH_MEAL_PLANE]({ commit }, data) {
    state.isLoading = true;
    return ApiService.get('/admin/mealplan', data)
      .then((res) => {
        commit(SET_MEAL_PLANE, res.data);
        return res;
      })
      .catch((error) => {
        state.isLoading = false;
        console.error(error);
        return error.response.status;
      });
  },

  [FETCH_DISCOUNT_PRICE]({ commit }, params) {
    state.isLoading = true;
    return ApiService.post('/apply-global-promocode', params)
      .then(({ data }) => {
        commit(SET_DISCOUNT_PRICE, data.response);
        return data.response;
      })
      .catch((error) => {
        state.isLoading = false;
        return error.response.status;
      });
  },
  [VALIDATE_GLOBAL_PROMOCODE]({ commit }, params) {
    state.isLoading = true;
    return ApiService.post('/apply-global-promocode', params)
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        state.isLoading = false;
        return error.response.status;
      });
  },
  [FETCH_HOLD_TIMESTAMP]({ commit }, params) {
    state.isLoading = true;
    return ApiService.post('/RoomHoldSession', params)
      .then(({ data }) => {
        commit(SET_HOLD_TIMESTAMP, data);
        return data.response;
      })
      .catch((error) => {
        state.isLoading = false;
        console.error('SET_HOLD_TIMESTAMP', error.message);
        return error.response.status;
      });
  },
  [REMOVE_HOLD_ROOMS]({ commit }, params) {
    state.isLoading = true;
    return ApiService.put(`/booking/releaseRoom/${params.roomId}`, params)
      .then(({ data }) => {
        commit(SET_HOLD_TIMESTAMP, { data: null });
        return data.response;
      })
      .catch((error) => {
        state.isLoading = false;
        console.error('SET_HOLD_TIMESTAMP', error.message);
        return error.response.status;
      });
  },
  [VALIDATE_ROOM_CREATE_BILLING]({ commit }, params) {
    state.isLoading = true;
    return ApiService.post('/booking/validateRoom', params)
      .then(({ data: { response: res } }) => {
        commit(SET_VALID_ROOM_AND_BILLING, res);
        return res;
      })
      .catch((error) => {
        state.isLoading = false;
        console.error('SET_VALID_ROOM_AND_BILLING', error.message);
        return error;
      });
  },
  [BUY_ROOM]({ commit }, params) {
    state.isLoading = true;
    return ApiService.post('/booking/buyroom', params)
      .then(({ data: { response: res } }) => {
        commit(SET_BOUGHT_ROOM, res);
        return res;
      })
      .catch((error) => {
        state.isLoading = false;
        console.error('SET_VALID_ROOM_AND_BILLING', error.message);
        return error.response.data.response;
      });
  },
  [FETCH_SMS_PRICE]({ commit }, params) {
    state.isLoading = true;
    return ApiService.get('/system-pricings', params)
      .then(({ data }) => {
        commit(SET_SMS_PRICE, data);
        return data;
      })
      .catch((error) => {
        state.isLoading = false;
        console.error('SET_SMS_PRICE', error.message);
        return error.response.data.response;
      });
  },
  [SAVE_API_BODY]({ commit }, apiBody) {
    commit(SET_API_BODY, apiBody);
  },
  [RESET_DISCOUNT_MESSAGE]({ commit }) {
    commit(SET_DISCOUNT_MESSAGE);
  },
  [HOTEL_PAYMENT_CANCEL](context, params) {
    ApiService.setHeader();
    return ApiService.put('booking/updateStatus/' + params.billingId, params)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
};

const mutations = {
  [SET_ROOM_PAYMENT_COMPLETE](state, res) { },
  [SET_HOME_HOTELS](state, res) {
    if (res.data.length) state.homeHotels = res.data;
    state.homeHotelCount = res.count;
    state.isLoading = false;
  },
  [SET_PROPERTY_TYPE](state, res) {
    if (res.data.length) state.propertyTypes = res.data;
    state.propertyTypeCount = res.count;
    state.isLoading = false;
  },
  [SET_COUNTRIES](state, res) {
    if (res.data.length) state.countries = res.data;
    state.countryCount = res.count;
    state.isLoading = false;
  },
  [SET_REGION](state, res) {
    if (res.data.length) state.regions = res.data;
    state.regionCount = res.count;
    state.isLoading = false;
  },
  [SET_API_BODY](state, apiBody) {
    state.apiBody = apiBody;
  },
  [SET_HOTEL](state, res) {
    if (res.data) {
      // Check if data is an array (signix structure) or object (regular structure)
      const isSignixDataStructure = Array.isArray(res.data);
      
      if (isSignixDataStructure) {
        // Signix data: res.data is an array, transform the first hotel
        state.hotel = transformHotelDetailData(res.data[0]);
      } else {
        // Regular data: res.data is a single hotel object
        state.hotel = res.data;
      }
      state.isLoading = false;
    }
  },
  [SET_ALL_ROOMS_BY_HOTEL_ID](state, res) {
    if (res.data) state.allRoomsByHotelId = res.data;
    state.isLoading = false;
  },
  [SET_FILTERED_ROOMS](state, res) {
    if (res.data) {
      state.filteredRooms = res.data;
      state.filteredRoomsMsg = "";
    } else state.filteredRoomsMsg = res;
    state.isLoading = false;
  },
  [SET_FILTERED_HOTELS](state, res) {
    let isSignix = JSON.parse(localStorageServices.getObject("isSignix"));
    if (!isSignix) {
      state.isPromotionalExists = res.featured;
      state.filteredHotels = res.data;
      state.filterHotelsCount = res.count || 0;
      state.isLoadingHotels = false;

    } else {
      state.mealPlanNames = res.data.FiltersWithCount && res.data.FiltersWithCount.MealPlanNames;
      state.isPromotionalExists = res.data.hotels;
      state.filteredHotels = transformHotelData(res.data); // Apply 
      state.filterHotelsCount = res.data.TotalHotels || 0;
    }
  },
  [SET_HOTEL_NAMES](state, res) {
    if (res.data) state.hotelNames = res.data;
    state.isLoading = false;
  },
  [SET_MEAL_PLANE](state, res) {
    if (res.data) state.mealPlans = res.data;
    state.isLoading = false;
  },
  [SET_VALID_ROOM_AND_BILLING](state, res) {
    if (res.data) {
      state.isLoading = false;
      state.roomBilling = res.data;
    }
  },
  [SET_FINAL_TRANSACTION](state, transaction = null) {
    if (transaction) {
      state.final_transaction = transaction;
    }
  },
  [SET_HOLD_TIMESTAMP](state, res) {
    if (res.data) state.cachedTime = _.get(res, "data.timeRemaining", null);
    state.isLoading = false;
  },
  [SET_DISCOUNT_MESSAGE](state, res) {
    state.discountedPrice.message = null;
  },
  [SET_DISCOUNT_PRICE](state, res) {
    if (res.data) {
      state.discountedPrice.discount = res.data;
      state.discountedPrice.message = null;
    }
    if (!res.data) {
      state.discountedPrice.message = res.message;
      state.discountedPrice.discount = null;
    }
    state.isLoading = false;
  },
  [SET_BOUGHT_ROOM](state, res) {
    if (res.data) state.boughtRoom = res.data;
    state.isLoading = false;
  },
  [SET_SMS_PRICE](state, res) {
    if (res.data) state.systemPricing = res.data;
    state.isLoading = false;
  },
  [RESET_STATE](state, res) {
    state.filteredRooms = null;
    state.roomBilling = null;
    state.boughtRoom = {};
    state.apiBody = {};
    state.discountedPrice = { message: "", discount: null };
  },
  [RESET_DISCOUNT_PRICE](state) {
    state.discountedPrice = { message: "", discount: null };
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
